import { useRouter } from 'next/router'

import { BootcampPageUrlParamsType, LevelActionType } from '../types/bootcamp.types'
import { GRADE_QUERY_PARAM } from '../constants/bootcamp.const'

/**
 * Check if the current bootcamp page is a grade page or came from grade overview.
 * @returns boolean
 */
function useIsBootcampGradePage(): boolean {
  const { query } = useRouter()
  const { action } = query as unknown as BootcampPageUrlParamsType

  const showGradeQuery = Boolean(query[GRADE_QUERY_PARAM] === 'true')

  const isGradePage = showGradeQuery && action !== LevelActionType.Quiz

  return isGradePage
}

export default useIsBootcampGradePage
